"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnlineDataLookup = void 0;
const client_1 = require("@apollo/client");
const isObject_1 = __importDefault(require("lodash/isObject"));
const graphql_1 = require("../utils/graphql");
const aggregate_1 = require("../utils/aggregate");
const configContext_1 = require("../contexts/configContext");
// TODO [S5-3129]: Rename to Online (along with `useOfflineProximityLookup.ts`) when mobile/desktop offline strategy is implemented.
const useOnlineDataLookup = () => {
    const { aggregateDefinitions } = (0, configContext_1.useConfig)();
    const apolloClient = (0, client_1.useApolloClient)();
    const onlineLookup = (aggregateType, attributeName, attributeValue, limit) => {
        const aggDef = aggregateDefinitions.find(agg => agg.name === aggregateType);
        const queryKey = aggDef === null || aggDef === void 0 ? void 0 : aggDef.queryKey;
        if (!queryKey) {
            return [];
        }
        // we need to check our attribute name against the properties to see if it's a relationship type
        const searchProperty = aggDef === null || aggDef === void 0 ? void 0 : aggDef.propertyDefinitions.find(prop => prop.field === attributeName);
        if (!searchProperty) {
            return [];
        }
        //TODO: This is a hack for a last min release. Linked Property are being set to {id:string, label:string} on the current aggregate
        //state. Not entirely sure why this is but we need to update it to be only the string id of the aggregate of update it in the accessor before sending to mappings.
        //JIRA BUG https://terrago.atlassian.net/browse/S5-2126
        const deconstructionOfAttributeValue = (value) => {
            if ((0, isObject_1.default)(value) && value.hasOwnProperty('id')) {
                return value.id;
            }
            return value;
        };
        const deconstructedValue = deconstructionOfAttributeValue(attributeValue);
        const condition = searchProperty.isRelationship &&
            (searchProperty.relationshipType === 'ONE_TO_ONE' || searchProperty.relationshipType === 'ONE-TO-ONE')
            ? `${attributeName}Id:"${deconstructedValue}"`
            : `${attributeName}:"${deconstructedValue}"`;
        return apolloClient
            .query({
            query: (0, client_1.gql) `
	query useOfflineDataLookup { ${queryKey}(condition: {${condition}}, first: ${limit}){
	  ${(0, graphql_1.getAggregateDataFields)(aggDef)}
	} }
	`,
            fetchPolicy: 'no-cache',
        })
            .then(res => {
            return res.data
                ? res.data[queryKey].map((row) => (0, aggregate_1.graphqlToAssetTransform)({ flattenRelationships: true, result: row, aggDef: aggDef }))
                : [];
        });
    };
    return onlineLookup;
};
exports.useOnlineDataLookup = useOnlineDataLookup;
//# sourceMappingURL=useOnlineDataLookup.js.map